<!-- Reached by a stale in-app link and by a scanned QR URL that arrived without its token, so
     it carries no shell and names no module: the hint covers the scan, the card covers the rest. -->
<main class="kuba-not-found">
  <div class="kuba-not-found-card">
    <img
      src="assets/images/not-found-image.png"
      alt=""
      aria-hidden="true"
      class="kuba-not-found-image"
    />
    <h1 [translate]="'PAGE_NOT_FOUND_TITLE'"></h1>
    <p [translate]="'PAGE_NOT_FOUND_MESSAGE'"></p>

    <div class="kuba-not-found-hint">
      <i class="pi pi-info-circle"></i>
      <span [translate]="'PAGE_NOT_FOUND_HINT'"></span>
    </div>

    <button type="button" class="kuba-not-found-btn" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span [translate]="'PAGE_NOT_FOUND_BACK'"></span>
    </button>
  </div>

  <img src="assets/images/KubaLogo.png" alt="Kuba" class="kuba-not-found-logo" />
</main>
